import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Form from '.';

export interface INewsletterFullProps extends IBaseElementProps {
	image?: IImage;
	heading?: string;
	text?: string;
}

/**
 * Newsletter Full
 * @block
 * @requiresHooks
 * @icon feedback
 */
const NewsletterFull: React.FC<INewsletterFullProps> = ({
	className,
	classNames = [],
	image,
	heading,
	text,
	children,
}) => (
	<div className={className || cn('newsletter-full', ...classNames)}>
		<div className="newsletter-full__content">
			{image && <Image {...image} />}
			{heading && <h2 className="newsletter-full__heading">{heading}</h2>}
			{text && <div className="newsletter-full__text">{text}</div>}
		</div>
		<div className="newsletter-full__form">
			<Form>{children}</Form>
		</div>
	</div>
);

export default NewsletterFull;
